import { useCallback, useState } from 'preact/hooks';
import { log } from '@/utils';

interface UseAddToCartOfferProps {
  cartId: string;
  variantId?: number;
}

export const useAddOfferToCart = ({
  cartId,
  variantId,
}: UseAddToCartOfferProps) => {
  const [isLoading, setLoading] = useState(false);

  const onAddOfferToCart = useCallback(
    async (activeOffer: string | number | null) => {
      if (!activeOffer || variantId === undefined) {
        console.error('Cannot add offer: activeOffer or variantId is missing.');
        return;
      }

      setLoading(true);

      try {
        const offerIdAsNumber = +activeOffer;

        const payload = {
          cart_id: cartId,
          variant_id: variantId,
          'offering_ids[]': [offerIdAsNumber],
        };

        const res =
          await window.itsServices.api.addServiceOfferingsToCart(payload);

        if (res.meta.status === 'success') {
          log.info('Offer Added to Cart');
        } else {
          log.error('Failed to add offer to cart:', { res });
        }
      } catch (error) {
        log.error('An error occurred during add to cart:', { error });
      } finally {
        setLoading(false);
      }
    },
    [cartId, variantId],
  );

  return {
    isLoading,
    onAddOfferToCart,
  };
};
